module.exports = __webpack_public_path__ + "img/bg_我的大师等级.94d10759.png";